/* GLOBAL LANGUAGE SETTINGS ***************************************************/

import { SUCCESS_SUFFIX, FAIL_SUFFIX, PROGRESS_SUFFIX } from 'util/dataprovider'
import { makeAction } from 'util/reduxhelper'

/**
* Set language by language code
* en or de
**/
export const SAVE = 'language/SAVE'
export const save = (language) => {
  return makeAction(SAVE, language)
}
/* automated for convenience @see dataprovider */
export const SAVE_FAIL = SAVE + FAIL_SUFFIX
export const SAVE_SUCCESS = SAVE + SUCCESS_SUFFIX

/**
* Load lang settings from local storage
**/
export const FETCH = 'language/FETCH'
export const fetch = () => {
  return makeAction(FETCH)
}
/* automated for convenience @see dataprovider */
export const FETCH_FAIL = FETCH + FAIL_SUFFIX
export const FETCH_SUCCESS = FETCH + SUCCESS_SUFFIX



// WEBPACK FOOTER //
// ./src/app/react-redux/actions/language.js